import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enJSON from './locale/en.json';
i18n.use(initReactI18next).init({
  resources: {
    en: { ...enJSON },    
  },
  lng: "en",
  fallbackLng: 'en',
  ns: ['translation'],
  defaultNS: 'translation',
});

// src/i18n.js
// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';

// const resources = {
//   en: {
//     translation: {
//       site_name: "Welcome",
//       cart_items_txt: "Cart Items"
//     }
//   },
//   hi: {
//     translation: {
//       welcome: "स्वागत है",
//       cart_items_txt: "कार्ट आइटम"
//     }
//   }
// };

// i18n
//   .use(initReactI18next)
//   .init({
//     resources,
//     lng: 'en', // default language
//     fallbackLng: 'en',
//     interpolation: {
//       escapeValue: false
//     }
//   });

// export default i18n;
